import { render, staticRenderFns } from "./NewsletterForm.vue?vue&type=template&id=ab59c07e&"
import script from "./NewsletterForm.vue?vue&type=script&lang=js&"
export * from "./NewsletterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports